import React, { useState, useEffect } from 'react'

import { Icon, IconButton, MenuItem, TextField, Typography } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { KeyboardDatePicker } from '@material-ui/pickers'

import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'

import moment from 'moment'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px',
		'& .MuiFilledInput-underline': {
			minWidth: '380px !important'
		},
		'& .MuiTextField-root': {
			minWidth: '380px !important'
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		}
	}
}))

export const CustomAddOnOccurence = (props) => {
	const classes = useStyles()
	let { customDate, updateCustomDate, deleteCustomDate, timeBlocks } = props
	const visit = useSelector((state) => state.specific.visits.selected)

	const [isCalendarOpen, setIsCalendarOpen] = useState(false)
	const [date, setDate] = useState(null)
	const [timeBlock, setTimeBlock] = useState(null)

	useEffect(() => {
		if (date !== customDate.date) {
			setDate(customDate.date)
		}

		if (timeBlock !== customDate.time) {
			setTimeBlock(customDate.time)
		}
	}, [customDate])

	const updateDate = (date) => {
		if (date) {
			customDate.date = date
		}

		setDate(moment(date).format('ll'))
		updateCustomDate(customDate)
	}

	const updateTimeBlock = (timeBlock) => {
		if (timeBlock) {
			customDate.time = timeBlock
		}

		setTimeBlock(timeBlock)
		updateCustomDate(customDate)
	}

	return (
		<div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
			<div className={classes.fieldWrapper} style={{ position: 'relative' }}>
				<Typography variant="overline" style={{ fontSize: '12px' }}>
					On this date
				</Typography>
				<KeyboardDatePicker
					disableToolbar
					style={{
						minWidth: '400px',
						margin: 0
					}}
					InputAdornmentProps={{
						position: 'start',
						component: () => (
							<IconButton onClick={() => setIsCalendarOpen(true)}>
								<Icon
									className="far fa-calendar-alt"
									style={{
										fontSize: '1.325rem'
									}}
								/>
							</IconButton>
						)
					}}
					InputProps={{
						error: customDate.dateError
					}}
					open={isCalendarOpen}
					onClose={() => setIsCalendarOpen(false)}
					variant="inline"
					format="MM/DD/YYYY"
					margin="normal"
					label="Date"
					inputVariant="filled"
					value={date}
					onChange={(date) => {
						updateDate(date.clone().hour(12))
					}}
					className={classes.datePicker}
					rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
					leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
					KeyboardButtonProps={{
						'aria-label': 'Date',
						className: classes.calendarButton
					}}
					minDate={visit && visit.dates.length > 1 ? visit.dates[0] : null}
					maxDate={visit && visit.dates.length > 1 ? visit.dates[visit.dates.length - 1] : null}
					disablePast
					helperText={customDate.dateError ? 'Please select a date.' : null}
				/>
			</div>
			<div className={classes.fieldWrapper}>
				<Typography variant="overline" style={{ fontSize: '12px' }}>
					At this time of day
				</Typography>
				<TextField
					id="time-select"
					variant="filled"
					select
					label="Time Block"
					value={timeBlock || ''}
					onChange={(e) => updateTimeBlock(e.target.value)}
					InputProps={{ className: timeBlock ? classes.selected : '' }}
					error={customDate.timeBlockError}
					helperText={customDate.timeBlockError ? 'Please select a time block.' : null}>
					{timeBlocks.map((timeBlock) => (
						<MenuItem key={timeBlock} value={timeBlock}>
							{timeBlock}
						</MenuItem>
					))}
				</TextField>
			</div>
			<Icon
				className="fas fa-minus-circle"
				onClick={() => deleteCustomDate(customDate)}
				style={{
					fontSize: '1.325rem',
					color: '#EB4C4C',
					marginLeft: '24px',
					cursor: 'pointer'
				}}
			/>
		</div>
	)
}
